import { Hidden } from '@material-ui/core'

import PageHeader from '../../components/PageHeader'
import { getRoleFromStorage } from '../../helpers/userData'
import { getTranslate } from '../../localization'
import sitekeyPagesRoleManagement from '../../staticRoleManagement/sitekeyRoleManagement'
import SitekeysListDesktop from './SitekeysListDesktop'
import SitekeysListMobile from './SitekeysListMobile'

const SitekeysList = () => {
  const hasAccessToAddNewSiteKey = sitekeyPagesRoleManagement
    .find((item) => item.route === '/sitekeys')
    ?.rolesListWithWriteAccess?.includes(getRoleFromStorage())

  const hasAccessToEditSiteKey = sitekeyPagesRoleManagement
    .find((item) => item.route === '/sitekeys/:id/edit')
    ?.rolesListWithReadAccess?.includes(getRoleFromStorage())

  return (
    <>
      <PageHeader title={getTranslate('Site keys List')} />
      <Hidden smDown>
        <SitekeysListDesktop
          hasAccessToAddNewSiteKey={hasAccessToAddNewSiteKey}
          hasAccessToEditSiteKey={hasAccessToEditSiteKey}
        />
      </Hidden>
      <Hidden mdUp>
        <SitekeysListMobile
          hasAccessToAddNewSiteKey={hasAccessToAddNewSiteKey}
          hasAccessToEditSiteKey={hasAccessToEditSiteKey}
        />
      </Hidden>
    </>
  )
}
export default SitekeysList
